export default __webpack_public_path__ + "static/rangeSelection-2f1bf5bd1d6940c2625bbeb703af07a1.gif";